<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Enqueue :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">{{ enqueue }}</v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Exclusive :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">{{ exclusive }}</v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';

export default {
  mixins: [instanceable, contextmenuable],
  data() {
    return {
      enqueue: 0,
      exclusive: 0,
      contextLinkType: 'system',
      contextmenuUrl: '/views/detailview/abap/ci',
    };
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => every(key, response));
    },
    wsDataHandler(key, response) {
      if (key.name == 'rawEnqueueLock') this.enqueue = response.length;
      else if (key.name == 'rawExclusiveLock') this.exclusive = response.length;
    },
  },
  created() {
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'rawEnqueueLock', sstmId: this.instance.systemId },
          fields: ['stime'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: 'rawExclusiveLock', sstmId: this.instance.systemId },
          fields: ['stime'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
      ],
    });
  },
};
</script>
